import { render, staticRenderFns } from "./glucoseStatisticList.vue?vue&type=template&id=ec8f3554"
import script from "./glucoseStatisticList.vue?vue&type=script&lang=js"
export * from "./glucoseStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports